import { Wording } from '@/types';

export const YOGA_WORDING_RO: Wording = {
  components_header_media_content: 'Antrenamente',
  components_header_media_1: '',
  components_header_media_2: '',
  components_header_text1: 'Rețete',
  components_header_text2: 'Blog',
  components_header_members: 'Membrii',
  hero_text: 'Păstrați-vă corpul flexibil și puternic',
  hero_button_text: 'Începe-ți călătoria yoga',
  components_ressources_section_title: 'RESURSE',
  components_ressources_subheader_text:
    'Toate resursele de care aveți nevoie pentru un stil de viață armonios',
  components_ressources_span_text:
    'Deblocați secretele bunăstării: scufundați-vă într-o colecție de ipostaze de yoga, meditații conștiente și rețete sănătoase pentru a crea echilibru în fiecare aspect al vieții tale.',
  components_ressources_card_1_title: 'Sfaturi de yoga',
  components_ressources_card_1_text:
    'Sfaturi practice pentru a-ți aprofunda practica și a-ți perfecționa ipostaza.',
  components_ressources_card_2_title: 'Dieta',
  components_ressources_card_2_text:
    'Sfaturi inteligente de nutriție pentru o persoană mai sănătoasă și mai puternică.',
  components_ressources_link: 'Vizionați videoclipuri',
  components_notes_and_google_title_1: 'Antrenamente yoga',
  components_notes_and_google_title_2: 'Rutină obișnuită',
  components_notes_and_google_title_3: 'Menținerea dietei',
  components_review_google_text: 'Recenzie pe Google',
  media_content_section_title: 'ANTRENAMENTE',
  media_content_section_subheader_text: 'Videoclipurile noastre',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Mai multe videoclipuri',
  text2_section_title: 'BLOG',
  text2_section_subheader_text: 'Articole și știri',
  text2_section_button_more: 'Mai multe articole',
  components_text1_section_title: 'REȚETE',
  components_text1_subheader_text: 'Hrănește-ți corpul și mintea',
  components_text1_span_text:
    'Rețete sănătoase pentru a vă sprijini practica de yoga și pentru a vă îmbunătăți bunăstarea.',
  components_text1_card_1_title: 'Mic dejun energizant',
  components_text1_card_1_text:
    'Treziți-vă cu mese vibrante, care stimulează energia.',
  components_text1_card_3_title: 'Prânzuri la pachet cu putere',
  components_text1_card_3_text:
    'Descoperiți rețete de prânz delicioase și convenabile, concepute pentru stilul dvs. de viață activ. De la salate colorate la ambalaje bogate în proteine, aceste rețete vă mențin alimentat și concentrat.',
  components_text1_card_2_title: 'Cine pentru recuperare',
  components_text1_card_2_text:
    'Explorați o varietate de proteine ​​slabe, cereale integrale și legume vibrante pentru un sfârșit satisfăcător al zilei.',
  components_text1_link: 'Vezi toate rețetele',
  components_footer_text:
    'Găsește echilibrul, respira adânc: yoga ta, călătoria ta.',
  components_footer_info: 'Info',
  components_footer_registration_number: 'Număr de înregistrare',
  components_footer_legal: 'Legal',
  components_footer_terms: 'Termeni și condiții',
  components_footer_privacy: 'Politica de confidențialitate',
  button_load_more: 'Încărcați mai multe',
  page_media_1_content_hero_text: 'Antrenamente de yoga',
  page_text1_hero_text: 'Rețete',
  page_text1_section_title: 'Nutriţie',
  page_text1_subheader_text: 'Rețete',
  page_text2_hero_text: 'Blogul nostru',
  page_text2_section_title: 'Blog',
  page_text2_subheader_text: 'Articole și știri',
  enter_email_title:
    'Vă rugăm să introduceți adresa dvs. de e-mail pentru a continua',
  enter_email_placeholder_email: 'E-mail',
  enter_email_button_enter: 'Intră',
  components_login_success_text: 'Conectare reușită!',
  components_card_link_media_content: 'Urmăriți acum',
  components_card_link_text1_content: 'Vezi Rețeta',
  components_card_link_text2_content: 'Vezi articolul',
  france: 'Franţa',
  cyprus: 'Cipru',
};
